export default "__VITE_ASSET__CEd9Y5oi__"